export enum AuxSelectorDataType {
    Tags = 1,
    ProjectStage = 2,
    Workers = 3,
    Clients = 4,
    Projects = 5,
    LinearChartWorkers = 6,
    Parameters = 15,
    StringSets = 16,
    Lists = 17,
    BillsForMovement = 18,
    ProjectsForMovement = 19,
    StorageItems = 20,
    DefaultParameterHints = 21,
    Storages = 22,
    MovementStorages = 23,
    StorageItemCommentTemplates = 24,
    MovementCommentTemplates = 25,
    BillsForExistingMovement = 26,
    ClientsToReattach = 27,
    Counterparties = 28,
    BillsForProject= 29,
    CustomParameterHints = 30,
    AddressHints = 31,
    InstanceValueSet = 32,
    TableCommentTemplates = 33,
}
